import { configuratorActions } from '../../services';

const arraySliceTester = /^(?<array>([a-zA-Z0-9_]{1,}))\[(?<index>(\d){1,})\]$/ig;

function findModel( configuration, materialKey ) {
  if( configuration.materialKey === materialKey ) {
    return configuration;
  }
    
  const children = configuration.children || configuration.configuration && configuration.configuration.children;

  if( children ) {
    for( let child of children ) {
      const result = findModel( child.childTemplate, materialKey );
      if( result ) {
        return result;
      }
    }
  }
  return null; 
}

// function applyDeltaConfiguration( configuration, template, state, action ) {
//   if( !Object.keys( action.changes ).length && action.validity.isValid ) {
//     return state;
//   }
  
//   const functionBody = 'let model = JSON.parse( JSON.stringify( old ) );\n' + Object.entries( action.changes ).map( entry => {
//     let label = entry[0];
    
//     if ( label.includes( 'existingAssignments' ) ) {
//       return undefined;
//     }

//     if ( entry[1] === null ) {
//       const result = /^(?<array>([a-zA-Z0-9_]{1,}))\[(?<index>(\d){1,})\]$/ig.exec( label );
//       if ( result ) {
//         const { array, index } = result.groups;
//         if ( array && index ) {
//           // this would be an entry which got deleted from an array, so we would have to slice here
//           return `model.${array}.splice( ${index}, 1 );`;
//         }
//       }
//       return `delete model.${label};`;
//     }

//     return `model.${label} = ${JSON.stringify( entry[1] )};`;
//   } ).join( '\n' ) + '\nreturn model;';

//   try {
//     const fn = new Function( 'old', functionBody );
//     const defaultBomComponents = template.productModelType === 1 ? [{itemId:0, itemNumber:0,component:''}] : [];
//     const result = fn( { ...template, bomComponents: template.bomComponents || defaultBomComponents , validity: action.validity, products: action.products } );
//     //To ensure no empty values are there in bomComponents when remove button is clicked
//     result.bomComponents = result.bomComponents.filter(bom => bom); 
//     template.model = result.model;
//     template.bomComponents = result.bomComponents || [];
//     template.validityInfo = result.validity;
//     template.products = result.products;
//     template.optimizedModel = '';
//     template.filters = [];
//     template.masterFilter = '';
//   } catch( e ) {
//     console.error( functionBody );
//     throw e;
//   }

//   return configuration;
// }
function applyDeltaConfiguration( configuration, template, state, action ) {
  if( !Object.keys( action.changes ).length && action.validity.isValid ) {
    return state;
  }
 
  const functionBody = 'let model = JSON.parse( JSON.stringify( old ) );\n' + Object.entries( action.changes ).reverse().map( entry => {
    let label = entry[0];
   
    if ( label.includes( 'existingAssignments' ) ) {
      return undefined;
    }
 
    if ( entry[1] === null ) {
      const result = /^(?<array>([a-zA-Z0-9_]{1,}))\[(?<index>(\d){1,})\]$/ig.exec( label );
      if ( result ) {
        const { array, index } = result.groups;
        if ( array && index ) {
          // this would be an entry which got deleted from an array, so we would have to slice here
          return `model.${array}.splice( ${index}, 1 );`;
        }
      }
      return `delete model.${label};`;
    }
 
    return `model.${label} = ${JSON.stringify( entry[1] )};`;
  } ).join( '\n' ) + '\nreturn model;';
 
  try {
    const fn = new Function( 'old', functionBody );
    const defaultBomComponents = template.productModelType === 1 ? [{itemId:0, itemNumber:0,component:''}] : [];
    const result = fn( { ...template, bomComponents: template.bomComponents || defaultBomComponents , validity: action.validity, products: action.products } );
    //To ensure no empty values are there in bomComponents when remove button is clicked
    result.bomComponents = result.bomComponents.filter(bom => bom);
    template.model = result.model;
    template.bomComponents = result.bomComponents || [];
    template.validityInfo = result.validity;
    template.products = result.products;
    template.optimizedModel = '';
    template.filters = [];
    template.masterFilter = '';
  } catch( e ) {
    console.error( functionBody );
    throw e;
  }
 
  return configuration;
}

export const configuratorReducer = ( state = {}, action ) => {
  const productName = action.product && action.product.name ? action.product.name : action.product;
  const key = action && action.key && action.key.toLowerCase && action.key;
    
  switch ( action.type ) {
    case configuratorActions.LOADED:
      return { ...state, [productName]: { ...Object.values( action.productData ) }, _active: { ...Object.values( action.productData ) } };
    case configuratorActions.LOADEDFROMMODELCONFIGURATOR:
      return { ...state, [action.product.nodeCID]: action.product };
    case configuratorActions.REMOVEFROMMODELCONFIGURATOR:
      return { ...state, [action.product.nodeCID]: undefined };  
    case configuratorActions.HARDRESET:
      return { ...state, [productName]: undefined };
    case configuratorActions.RESET:
      return { ...state, [productName]: undefined };
    case configuratorActions.COMPLETE:
      const newState = { ...state };
      const similarKey = key.toLowerCase();
      const configurations = JSON.parse( JSON.stringify( newState[key] || newState[similarKey] ) );
      const template = Object.values( configurations ).map( configuration =>  findModel( configuration, action.materialKey || action.configuration )).firstOrDefault(v=>v);

      let firstTemplate = []
      if(!state["template"] || state.template?.materialKey!==template?.materialKey){
        firstTemplate = JSON.parse(JSON.stringify(template))
      }
      else{
        firstTemplate = state["template"]
      }

      if( action.changes ) {
        return { ...newState, [key]: applyDeltaConfiguration( configurations, template, state, action ),['template']:firstTemplate };
      }

      template.model = action.model;
      template.bomComponents = action.bomComponents;
      template.assignments = action.existingAssignments;
      template.validityInfo = action.validity;
      return { ...newState, [key]: configurations,['template']:firstTemplate };
    case configuratorActions.PRODUCTCHECK:
      // console.log(action.productsAvailable,'productsAvailable');
      return {...state, productsAvailable:action.productsAvailable};
      case configuratorActions.ProductsRESET:
        return {...state, productsAvailable:false};  
    default:
      return state;
  }
};
